import React, { useState, useRef, useEffect } from 'react';
import './VideoTaskModalContent.css';

export default function VideoTaskModalContent({ onClose, data, changeUrl }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null); // 'v1' | 'v2'

  const videoRef1 = useRef(null);
  const videoRef2 = useRef(null);

  const openModal = (key) => {
    setActiveVideo(key);
    setIsOpen(true);
    // изчакваме рендър на модала и пускаме видеото
    setTimeout(() => {
      const ref = key === 'v1' ? videoRef1 : videoRef2;
      ref.current?.play().catch(() => { });
    }, 60);
  };

  const closeModal = () => {
    const ref = activeVideo === 'v1' ? videoRef1 : videoRef2;
    if (ref?.current) {
      ref.current.pause();
      ref.current.currentTime = 0;
    }
    setIsOpen(false);
    setActiveVideo(null);
  };

  // Забрана за скрол на фона, докато модалът е отворен
  useEffect(() => {
    if (isOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = prev; };
    }
  }, [isOpen]);

  // Затваряне с ESC
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && isOpen && closeModal();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen]);

  const handleSubmit = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    setTimeout(() => setIsSubmitting(false), 3000); // имитация на заявка
    onClose();
  };

  return (
    <>
      <div className="modal-image">
        <img src={require("./assets/reel-icon.png")} alt="Film reel" />
      </div>

      <div className="modal-text">
        <p>
          Record a short selfie video talking about our app and the payment you received.
          Share how fast and easy it was, post it on your favorite platform, and drop the link below. After approval, you will earn $0.05! keep it real and positive!
          Once it is live, drop the link below. After approval, you will earn<strong> $0.05  easy cash just for sharing your success!</strong>
        </p>

        <span
          className="cursor-pointer"
          onClick={() => openModal('v1')}
        >
          Example 1
        </span>
        <span
          className="px-4 cursor-pointer"
          onClick={() => openModal('v2')}
        >
          Example 2
        </span>

      </div>

      {/* FULL-VIEWPORT МОДАЛ (не е native fullscreen) */}
      {isOpen && (
        <div
          className="video-modal-overlay"
          onClick={(e) => {
            // затваряме само ако кликът е върху бекдропа
            if (e.target.classList.contains('video-modal-overlay')) closeModal();
          }}
        >
          <button className="video-modal-close" onClick={closeModal} aria-label="Close video">
            ✕
          </button>

          {/* Показваме само активното видео */}
          {activeVideo === 'v1' && (
            <video
              ref={videoRef1}
              className="video-el"
              controls
              playsInline
              preload="metadata"
              src={require('./assets/man.webm')}
            />
          )}
          {activeVideo === 'v2' && (
            <video
              ref={videoRef2}
              className="video-el"
              controls
              playsInline
              preload="metadata"
              src={require('./assets/woman.webm')}
            />
          )}
        </div>
      )}

      <div className="modal-input-row my-2">
        <input
          type="text"
          placeholder="Submit Link"
          onChange={(e) => changeUrl(e.target.value)}
        />
        {/* <button className="arrow-btn">→</button> */}
      </div>

      <button
        onClick={handleSubmit}
        className="submit-btn"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Submitting..." : "SUBMIT"}
      </button>
    </>
  );
}
